import PropTypes from "prop-types";
import {createNotification} from "app/actions/notifications";
import {destroy as destroyRecord} from "app/requests/admin/categories";
import {displayDate} from "lib/ext/string";
import useAppContext from "lib/hooks/use-app-context";

function AdminCategoriesListRow({onDestroy, record}) {
  const {dispatch} = useAppContext();
  const onDelete = () => {
    if(!window.confirm("Are you sure you want to delete this category?")) { return; }

    destroyRecord(record.id).then(({message, success}) => {
      dispatch(createNotification({content: message, type: success ? "success" : "error"}));

      if(success) { onDestroy(record.id); }
    });
  };

  return (
    <tr>
      <td>{record.name}</td>
      <td>{record.display}</td>
      <td>{record.layout}</td>
      <td>{displayDate(record.created_at)}</td>
      <td>
        <div className="btn-group" role="group" aria-label="Actions">
          <a className="btn btn-sm btn-green" href={`/categories/${record.id}`} rel="noopener noreferrer" target="_blank">View</a>
          <a className="btn btn-sm btn-blue" href={`/admin/categories/${record.id}`}>Edit</a>
          <button type="button" className="btn btn-sm btn-red" onClick={onDelete}>Destroy</button>
        </div>
      </td>
    </tr>
  );
}

AdminCategoriesListRow.propTypes = {
  onDestroy: PropTypes.func.isRequired,
  record: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    layout: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default AdminCategoriesListRow;
